import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Check for new auth_token in query params (new Google OAuth flow)
        const searchParams = new URLSearchParams(location.search);
        const authToken = searchParams.get("auth_token");
        
        if (authToken) {
          await processGoogleCallback(authToken);
          // Clear the token from URL
          window.history.replaceState(null, "", "/");
          navigate("/", { replace: true });
          return;
        }
        
        // Legacy: Extract session_id from URL fragment (Emergent Auth)
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get("session_id");

        if (sessionId) {
          await processGoogleCallback(sessionId);
          // Clear the hash from URL
          window.history.replaceState(null, "", window.location.pathname);
          navigate("/", { replace: true });
        } else {
          navigate("/login", { replace: true });
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/login", { replace: true });
      }
    };

    processSession();
  }, [navigate, location.search, processGoogleCallback]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-void">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-purple animate-spin mx-auto mb-4" />
        <p className="text-slate-400">Completing sign in...</p>
      </div>
    </div>
  );
}
